module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921064149_T.264c208c.jpg";